import type { ReactNode } from 'react'
import { Icon, type IconGlyph } from '@sunwebgroup/uds-ui/icon'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { Tag } from '@sunwebgroup/ui-components/uds'
import styles from './InfoCard.module.css'

interface InfoCardProps {
  title: string
  titleId: string
  icon?: IconGlyph
  tag?: string
  children: ReactNode
}

export function InfoCard({ title, titleId, icon, tag, children }: InfoCardProps) {
  return (
    <section className={styles.card} aria-labelledby={titleId}>
      <div className={styles.header}>
        <div className={styles.headerTitle}>
          {icon && <Icon glyph={icon} size={24} aria-hidden="true" />}
          <Typography variant="display-g-regular" as="h3" id={titleId}>
            {title}
          </Typography>
        </div>
        {tag && (
          <Tag variant="neutral-tinted" size="M">
            {tag}
          </Tag>
        )}
      </div>
      {children}
    </section>
  )
}
